import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismButton } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';

interface HotelBenchmarkInsightButtonDesiredCompsetSignature {
  Args: {};
}

export default class HotelBenchmarkInsightButtonDesiredCompset extends Component<HotelBenchmarkInsightButtonDesiredCompsetSignature> {
  @service declare router: Services['router'];
  @service declare usageAnalytics: Services['usage-analytics'];

  @action
  onClick(): void {
    this.router.transitionTo('hotel.benchmark-insight.desired-compset');

    this.usageAnalytics.track('Compset Wishlist Editing', {
      eventTrigger: 'desired-compset-button',
    });
  }

  <template>
    <PrismButton
      @buttonType="secondary"
      @label={{t "benchmark_insight.desired_compset.track_compset_support"}}
      data-test-id="button-desired-compset"
      {{on "click" this.onClick}}
    />
  </template>
}
